export const LOGIN_SPLASH_IMAGES = [
  {
    id: "chemistry-flasks",
    label: "Chemistry flasks",
    alt: "Hands holding colourful chemistry flasks",
    url: "https://images.unsplash.com/photo-1554475901-4538ddfbccc2?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "lab-pipette",
    label: "Laboratory pipette",
    alt: "Pipette work in a science laboratory",
    url: "https://images.unsplash.com/photo-1748261347768-a32434751a9a?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "microscope-focus",
    label: "Microscope focus",
    alt: "Scientist adjusting a laboratory microscope",
    url: "https://images.unsplash.com/photo-1614308459036-779d0dfe51ff?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "microscope-stage",
    label: "Microscope stage",
    alt: "Microscope lenses above a specimen stage",
    url: "https://images.unsplash.com/photo-1614308460927-5024ba2e1dcb?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "science-demonstration",
    label: "Science demonstration",
    alt: "Adult and child carrying out a science experiment",
    url: "https://images.unsplash.com/photo-1758685734470-a75109299497?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    id: "science-classroom",
    label: "Science classroom",
    alt: "A science classroom with laboratory benches",
    url: "https://images.unsplash.com/photo-1763098844157-d0fffcc966a1?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const DEFAULT_LOGIN_COPY = {
  brand_name: "Ask Jonny",
  school_sign_in: "Sign in to your school",
  hero_eyebrow: "Science department assistant",
  hero_title: "Your prep room, one conversation away.",
  hero_body: "Book practicals, check your timetable and stock, and see what the technicians have prepared — just by asking Jonny.",
  email_label: "Email",
  password_label: "Password",
  sign_in_label: "Sign in",
  signing_in_label: "Signing in…",
  divider_label: "or",
  google_label: "Continue with Google",
  google_help: "Google sign-in works for accounts your department administrator has added.",
  signup_prefix: "New school?",
  signup_link_label: "Start a free trial",
  forgot_password_label: "Forgot password?",
  register_school_label: "Register your school",
  faq_label: "Frequently asked questions",
  manual_reassurance: "AI is optional. You can manage practicals, bookings, timetables and stock manually at any time.",
  splash_image_ids: LOGIN_SPLASH_IMAGES.map((image) => image.id),
  splash_mode: "random",
};

export const splashImageUrl = (imageId) => (
  `${process.env.REACT_APP_BACKEND_URL}/api/public/login-splash-images/${encodeURIComponent(imageId)}`
);

export const splashImagesWithUploads = (customImages = []) => [
  ...LOGIN_SPLASH_IMAGES,
  ...customImages.map((image) => ({
    ...image,
    alt: image.label,
    custom: true,
    url: splashImageUrl(image.id),
  })),
];

export const normaliseLoginCopy = (value) => ({
  ...DEFAULT_LOGIN_COPY,
  ...(value || {}),
  custom_images: Array.isArray(value?.custom_images) ? value.custom_images : [],
  splash_image_ids: value?.splash_image_ids?.length
    ? value.splash_image_ids
    : DEFAULT_LOGIN_COPY.splash_image_ids,
  splash_mode: value?.splash_mode === "static" ? "static" : "random",
});